import { Box } from "@mui/material";
import React from "react";

function Reorder({onClick}) {
  return (
    <Box
      component={"span"}
      sx={{
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2197_47964)">
          <path
            d="M0.662255 5.67307C0.664836 5.75967 0.701041 5.84187 0.76318 5.90224L2.09715 7.23557C2.12811 7.26661 2.16488 7.29124 2.20538 7.30804C2.24588 7.32485 2.28929 7.3335 2.33314 7.3335C2.37698 7.3335 2.4204 7.32485 2.4609 7.30804C2.5014 7.29124 2.53816 7.26661 2.56913 7.23557L3.90314 5.90224C3.93504 5.87144 3.96047 5.83458 3.97795 5.79382C3.99544 5.75306 4.00462 5.70923 4.00494 5.66488C4.00527 5.62053 3.99675 5.57656 3.97988 5.53555C3.963 5.49454 3.93808 5.45731 3.90663 5.42604C3.87519 5.39476 3.83786 5.37008 3.79675 5.35343C3.75565 5.33678 3.71161 5.3285 3.66726 5.32907C3.62292 5.32965 3.57912 5.33906 3.53846 5.35677C3.4978 5.37447 3.46109 5.40012 3.43046 5.43219L2.66552 6.19586L2.66552 1.00055C2.66552 0.912053 2.63036 0.827186 2.56778 0.764612C2.50521 0.702038 2.42032 0.666883 2.33183 0.666883C2.24334 0.666883 2.15849 0.702038 2.09592 0.764612C2.03334 0.827186 1.99818 0.912054 1.99818 1.00055L1.99819 6.1926L1.23581 5.43219C1.18915 5.38365 1.12886 5.35037 1.06292 5.33675C0.996973 5.32312 0.928454 5.32978 0.866372 5.35586C0.80429 5.38193 0.751559 5.42619 0.71512 5.48281C0.678682 5.53944 0.660264 5.60577 0.662255 5.67307ZM3.99622 2.33649C3.99675 2.40242 4.01681 2.46671 4.05389 2.52123C4.09096 2.57575 4.14337 2.61806 4.20449 2.6428C4.2656 2.66753 4.3327 2.67359 4.39726 2.66021C4.46182 2.64683 4.52095 2.6146 4.5672 2.5676L5.3328 1.80263L5.3328 6.99925C5.33471 7.08639 5.37069 7.16932 5.43299 7.23027C5.4953 7.29123 5.57898 7.32536 5.66614 7.32536C5.7533 7.32536 5.83702 7.29123 5.89932 7.23027C5.96163 7.16932 5.99757 7.08639 5.99948 6.99925L5.99948 1.80458L6.76446 2.5676C6.79435 2.6025 6.8311 2.63084 6.87246 2.65085C6.91382 2.67086 6.95889 2.6821 7.0048 2.68387C7.05071 2.68564 7.09647 2.67791 7.13925 2.66115C7.18203 2.64439 7.22091 2.61896 7.2534 2.58648C7.28589 2.55399 7.3113 2.51514 7.32806 2.47236C7.34482 2.42958 7.35256 2.3838 7.35079 2.33789C7.34901 2.29198 7.33777 2.24693 7.31776 2.20558C7.29775 2.16422 7.26942 2.12744 7.23452 2.09755L5.90117 0.76422C5.83871 0.702126 5.75421 0.667273 5.66614 0.667273C5.57806 0.667273 5.49357 0.702126 5.43111 0.76422L4.09714 2.09755C4.06521 2.12862 4.03981 2.16577 4.02248 2.2068C4.00514 2.24784 3.99622 2.29194 3.99622 2.33649Z"
            fill="#666E7D"
          />
        </g>
        <defs>
          <clipPath id="clip0_2197_47964">
            <rect
              width="8"
              height="8"
              fill="white"
              transform="translate(0 8) rotate(-90)"
            />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
}

export default Reorder;
